import PropTypes from 'prop-types';
import DatePickerDropdown from 'components/calendar/date-picker-dropdown';
import ClearCustomFieldButton from './clear-custom-field-button';

const CustomDateField = ({ value, customField = {}, handleChange = () => {}, handleTouched = () => {} }) => {
  return (
    <div className="interaction-custom-fields-form--input">
      <DatePickerDropdown
        triggerClassName="ignore-margin"
        date={value}
        onDayClick={(timestamp) => {
          handleChange(customField.id, timestamp);
          handleTouched();
        }}
      />

      {value ? <ClearCustomFieldButton onClick={() => handleChange(customField?.id, null)} /> : undefined}
    </div>
  );
};

CustomDateField.propTypes = {
  value: PropTypes.any,
  customField: PropTypes.shape({
    id: PropTypes.number.isRequired,
    displayName: PropTypes.string.isRequired,
    dataType: PropTypes.string.isRequired,
    required: PropTypes.bool,
    uiControlType: PropTypes.string,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleTouched: PropTypes.func,
};

export default CustomDateField;
